import DialogTitle from '@mui/material/DialogTitle'
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material'
import DialogContentText from '@mui/material/DialogContentText'
import { FC, forwardRef, ReactElement, Ref } from 'react'
import { TransitionProps } from '@mui/material/transitions'
import Slide from '@mui/material/Slide'

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement<any, any>
  },
  ref: Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />
})

interface ConfirmDialogProps {
  open: boolean
  title: string
  description: string
  onClose: () => void
  onConfirm: () => void
  confirmButtonText?: string
  cancelButtonText?: string
}

const ConfirmDialog: FC<ConfirmDialogProps> = ({
  open,
  title,
  description,
  onClose,
  onConfirm,
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
}) => {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant={'contained'}>
          {cancelButtonText}
        </Button>
        <Button onClick={onConfirm} variant={'outlined'} color={'error'}>
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDialog
